import React from 'react'

function UpdatePRServicesPage() {
  return <div className="page-container">update pr services</div>;
}

export default UpdatePRServicesPage;
